import {getHighlightedText} from "../../table-common/table-search";
import SortingIcon from "../../table-common/SortingIcon";
import PropTypes from "prop-types";
import React, {useCallback, useEffect, useState} from "react";
import {getUnitSortingFunction} from "../../table-common/table-sorting";
import UnitConsistTable from "./UnitConsistTable";
import {fetchConsistHistoryOfUnit} from "../../../service/consistHistoryService";

const TableHeader = ({sortingBy, sortReversed, changeSort}) => {
  return (
    <thead>
    <tr>
      <th onClick={() => changeSort('unit', false)}>
        Unit <SortingIcon
        visible={sortingBy === 'unit'} reversed={sortReversed}/>
      </th>
    </tr>
    </thead>
  )
}

TableHeader.propTypes = {
  sortingBy: PropTypes.string,
  sortReversed: PropTypes.bool,
  changeSort: PropTypes.func
}

const UnitDetails = ({unit}) => {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);

  let [sortingBy, setSortingBy] = useState('seen_date');
  let [sortReversed, setSortReversed] = useState(true);
  const changeSort = (newType, descending) => {
    if (sortingBy === newType) {
      setSortReversed(!sortReversed);
    } else {
      setSortingBy(newType);
      setSortReversed(descending === undefined || descending);
    }
  };

  const loadData = useCallback(async () => {
    const responseBody = await fetchConsistHistoryOfUnit({
      sortType: sortingBy.toUpperCase(),
      sortReverse: sortReversed,
      unit
    });
    setHistory(responseBody && responseBody.history || [{consist: 'Failed to load data.', seenDate: ''}]);
  }, [setLoading, setHistory]);
  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div className={"unit-details"}>
      <UnitConsistTable unit={unit}
                        history={history}
                        loading={loading}
                        sortingBy={sortingBy}
                        sortReversed={sortReversed}
                        changeSort={changeSort}/>
    </div>
  )
}

const UnitRow = ({unit, searchBy, open, toggle}) => {
  return (<button className={"unit"} onClick={toggle}>
    <i className={"fa fa-fw fa-chevron-" + (open ? "down" : "right")}/> {getHighlightedText(unit, searchBy)}
  </button>)
};

const TableRow = ({element, searchBy}) => {
  const [open, setOpen] = useState(false);
  return (
    <tr>
      <td>
        <UnitRow unit={element} open={open} searchBy={searchBy} toggle={() => setOpen(!open)}/>
        {open && <UnitDetails unit={element}/>}
      </td>
    </tr>
  )
};
TableRow.propTypes = {
  element: PropTypes.string,
  searchBy: PropTypes.string
}

const UnitTable = ({units, loading, searchBy}) => {
  let [sortingBy, setSortingBy] = useState('unit');
  let [sortReversed, setSortReversed] = useState(false);
  const changeSort = (newType, descending) => {
    if (sortingBy === newType) {
      setSortReversed(!sortReversed);
    } else {
      setSortingBy(newType);
      setSortReversed(descending === undefined || descending);
    }
  };

  let tableContent = (<tr>
    <td>No {searchBy ? "matching" : ""} data</td>
  </tr>);
  if (units.length) {
    tableContent = units
      .sort(getUnitSortingFunction(sortingBy, sortReversed))
      .map(unit =>
        (<TableRow
            key={unit}
            element={unit}
            searchBy={searchBy}/>
        ));
  }

  return (
    <div className="unit-table">
      {loading && <div className="loading-overlay"/>}
      <table aria-label="Units that have been seen on the trains">
        <TableHeader
          sortingBy={sortingBy}
          sortReversed={sortReversed}
          changeSort={changeSort}
          searchBy={searchBy}
        />
        <tbody>{tableContent}</tbody>
      </table>
    </div>
  );
};

export default UnitTable;
